import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { NotifService } from 'src/app/_services/notif.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: FormGroup;
  unknowError = false;
  isLoading = false;
  notLogged = false;
  isLoginError = false;
  isLoginSuccess = false;
  keepMeLoggedIn = false;
  isSubmitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private notifService: NotifService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/login']);
    }

    // Validateur du formulaire
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.route.queryParams.subscribe(params => {
      if (params.returnUrl) {
        this.notLogged = true;
      }
    });

  }

  get form() {
    return this.loginForm.controls;
  }

  onCheckboxClick(event: any) {
    this.keepMeLoggedIn = event.target.checked;
  }

  onSubmit() {
    console.log('on submit');
    this.isSubmitted = true;
    this.unknowError = false;
    this.isLoginError = false;
    this.isLoginSuccess = false;
    this.isLoading = false
    // Si la validation a echoué, on arrete l'execution de la fonction
    if (this.loginForm.invalid) {
      this.translate.get('Login.AUTH_LOGIN_FORM')
        .subscribe(val => this.notifService.danger(val));
      return;
    }

    this.isLoading = true;
    console.log('pret')

    this.authService.login(this.form.email.value, this.form.password.value, this.keepMeLoggedIn)
      .then(resp => {
        console.log('bon')
        this.authService.savePermissions(resp.permissions);
        this.authService.saveRoles(resp.roles);
        this.authService.saveToken(resp.token);
        this.authService.saveUser(resp.user);
        this.notifService.success('La connexion a reussie')
        this.router.navigate(['/home']);
      })
      .catch(err => {
        console.log(err)
        this.translate.get('Login.AUTH_LOGIN')
          .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }



}
